import type { PageCard } from '@/play/pageTypes'
import { OozePenCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'ooze-pen',
  number: 38,
  title: 'Ooze pen',
  question: "Does Oozery's goo feel like a fluid pen or marker when it falls a short way onto a flat sheet in a thin line?",
  status: 'open',
  accent: '#f6f4ee',
  CardArt: OozePenCardArt,
}
